module.exports = __webpack_public_path__ + "static/media/coursera-white.8ded208f.svg";